import moment from 'moment'
import React,{useState,useEffect} from 'react'
import { Attendance } from '../../sdk'
import { Loader } from '../Default'
import { DatePicker } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'
import { Iframe } from './Iframe'
export const MainContent=()=> {
  const [state,setState]=useState({loader:false,date:moment().format("yyyy-MM-DD"),type:0,data:[],tbHeader:[{title:"Employee Id",name:"time"},{title:"Employee Name",name:"cameraName"},{title:"Date",name:"lpValue"},{title:"Check in",name:"lpValue"},{title:"Check Out",name:"lpImage"}],updated:false,tableLoader:true});
  const apiData=async(date,type,updated=false)=>{
    try{
    let result=await new Attendance().getLiveAttendance();
    if(result.length){
      let arr=[];
      let count=1;
      for(let val of result){
       arr.push([val.employeeId,val.employeeName,val.date,val.checkIn?val.checkIn:"",val.checkOut?val.checkOut:""])
       count++;
      }
      setState((pre)=>{
        return {...pre,data:arr,loader:false,date,updated,tableLoader:false}
     })
    }
    else{
    setState((pre)=>{
        return {...pre,data:[],loader:false,date,updated,tableLoader:false}
     })
    }
   
    }catch(e){
    alert("error occur")
    }apiData();
    // const setTime=setInterval(()=>apiData(),1000 *2)
    // return ()=>{
    //   clearInterval(setTime);
    // }

}
const onHandlerMonth=(month)=>{
  setState((pre)=>{
    return {...pre,tableLoader:true}
  })
  apiData(moment(month).format("yyyy-MM-DD"),state.type,true)
}
const onHandlerType=(event)=>{
  setState((pre)=>{
    return {...pre,tableLoader:true}
  })
  apiData(state.date,event.target.value,true);
}

useEffect(()=>{
  // apiData();
  // const setTime=setInterval(()=>apiData(),1000 *2)
  // return ()=>{
  //   clearInterval(setTime);
  // }
 

},[])
if(!state.loader){
  return (
    <>
      <div className="card mb-3">
       {/* BEGIN card-body */}
       <div className="card-body">
   <div className="col-12">
     <div className="row">
       <div className="col-10">
       <div className="fw-bold mb-3">
   <span className="flex-grow-1 text-white">Vehicle</span>
   </div> 
       </div>
       {/* <div className="col-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" >Select Type</label>
        <select class="form-select" id="exampleFormControlSelect1" onChange={onHandlerType}>
          <option value="0">Default</option>
          <option value="1">Enter</option>
          <option value="1">Exit</option>
          </select>
          </div>
       </div> */}
       {/* <div className="col-2">
   <DatePicker type="Anpr" date={moment().subtract(1, 'day').format()} startDate={moment("2017").startOf('year').format()} endDate={moment().subtract(1, 'day').format()} handler={onHandlerMonth}/>
   </div> */}
     </div>
  
   </div>
   {state.tableLoader && <><Loader/></>}
   <div className="col-12">
    <div className="row">
    {/* <div className="col-12 col-md-12 col-lg-5">
  <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated}/>
  
   </div> */}
   <div class="col-12 col-md-12 col-lg-12">
            <div class="card mb-3">
            <div class="card-header fw-bold small" style={{textAlign:"center"}}>live Stream</div>
            <div class="card-body" >
<Iframe/>
           </div><div class="card-arrow"><div class="card-arrow-top-left"></div><div class="card-arrow-top-right"></div><div class="card-arrow-bottom-left"></div><div class="card-arrow-bottom-right"></div></div></div>
                </div>
    </div>
   </div>

  
   </div>
   <div className="card-arrow">
         <div className="card-arrow-top-left" />
         <div className="card-arrow-top-right" />
         <div className="card-arrow-bottom-left" />
         <div className="card-arrow-bottom-right" />
       </div>
   </div>
   <div class="modal" id="showImg">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      
      <div class="modal-body">
       <img id="modalImage" src='' alt="nothing" style={{width:"100%"}}/>
      </div>
     
    </div>
  </div>
</div>


 </>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}
